import React from 'react';
import { NavLink } from 'react-router-dom';
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import classes from './Menu.module.scss';
import { IMenuItem } from '../useMenuItems';

interface IProps {
  menuItems: IMenuItem[];
}

const Menu: React.FC<IProps> = ({ menuItems }) => {
  
  const menuItemClickHandler = (menuItem: IMenuItem): void => {
    const { link, onClick } = menuItem;
    if (link) {
      window.open(link, '_blank');
    } else if(onClick) {
      onClick();
    }
  };

  const createSubMenu = (menuItems?: IMenuItem[]) => {
    if (!menuItems || !menuItems.length) return null;
    let chunks: IMenuItem[][] = [];
    const oArray = [...menuItems];
    while (oArray.length) {
      chunks = [...chunks, [...oArray.splice(0, 4)]];
    }

    return (
      <div className={classes.SubMenu}>
        {chunks.map((chunk, i) => (
          <div key={i}>{chunk.map((menuItem) => renderMenuItem(menuItem, true))}</div>
        ))}
      </div>
    );
  };

  const renderMenuItem = (menuItem: IMenuItem, isSubMenuItem = false) => {
    const { text, menuItems, styles, to } = menuItem;
    const className = isSubMenuItem ? classes.SubMenuItem : classes.MenuItem;
    const Tag = isSubMenuItem ? "div" : "li";
    const activeClassName = isSubMenuItem ? classes.SubMenuItemActive : classes.MenuItemActive;
    const subMenu = createSubMenu(menuItems);

    const itemKey = menuItem.id?.toString() || (typeof text === 'string' ? text : undefined);

    if (to) {
      return (
        <Tag key={itemKey}>
          <NavLink
            to={to}
            className={(nav) => nav.isActive ? [activeClassName, className].join(' ') : className}
            style={styles}
            onClick={(e) => e.stopPropagation()}
          >
            {text}
            {subMenu && <FontAwesomeIcon className={classes.Icon} icon={faChevronDown} /> }
            {subMenu}
          </NavLink>
        </Tag>
      );
    } else if (menuItem.link) {
      return (
        <Tag key={itemKey}>
          <a
            href={menuItem.link}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
            style={styles}
            onClick={(e) => e.stopPropagation()}
          >
            {text}
            {subMenu && <FontAwesomeIcon className={classes.Icon} icon={faChevronDown} /> }
            {subMenu}
          </a>
        </Tag>
      );
    } else {
      return (
        <Tag key={itemKey} className={className} onClick={() => menuItemClickHandler(menuItem)} style={styles}>
          {text}
          {subMenu && <FontAwesomeIcon className={classes.Icon} icon={faChevronDown} /> }
          {subMenu}
        </Tag>
      );
    }
  };

  return (
    <>
      <nav style={{ display: "flex", flexGrow: 1 }}>
        <ul className={classes.MainMenu}>{menuItems.map((menuItem) => renderMenuItem(menuItem))}</ul>
      </nav>
    </>
  );
};

export default Menu;
